module.exports = __webpack_public_path__ + "static/media/achievement-show-off.9598aa29.svg";